import * as React from "react";

export default class LoadingIndicator extends React.Component {
    render() {
        return (
            <span>Loading...</span>
        );
    }
}
